import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/staffs/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/settings/staffs';

const Home: NextPage = () => (
  <>
    <NskHead title="担当者一覧" />
    <Component />
  </>
);

export default Home;
